export const CONVERSATIONS_CHANGED = 'softai:conversations-changed';

export const notifyConversationsChanged = (detail = null) => {
	window.dispatchEvent(
		new CustomEvent(CONVERSATIONS_CHANGED, {
			detail: detail || null,
		}),
	);
};
